<template>
  <span :class="{ 'pointer-events-none select-none blur-sm': isHidden }">
    {{ displayedText }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  text: string
  hiddenTextLength: number
}>()

const isHidden = computed(() => props.text === '(hidden)')
const displayedText = computed(() => {
  if (isHidden.value) {
    return Array.from({ length: props.hiddenTextLength }, () =>
      Math.random().toString(36).charAt(2),
    ).join('')
  }
  return props.text
})
</script>
